import { InlineButton } from '#components/atoms/buttons/inline-button/InlineButton.tsx';
import { Link } from '#components/atoms/link/Link.tsx';
import { AuthLayout } from '#components/patterns/layouts/auth/AuthLayout.tsx';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { useRequestedPlan } from '#hooks/useRequestedPlan.ts';

type Props = {
  children: React.ReactNode;
};

/**
 * Shared shell for the first-time MFA setup steps (choose / passkey / TOTP):
 * the auth chrome with a signout affordance plus the mock-only escape hatch.
 */
export function RegisterMFALayout({ children }: Props) {
  const auth = useAuth();
  const location = useAppLocation();
  const [plan, clearPlan] = useRequestedPlan();

  return (
    <AuthLayout
      headerText={
        auth.user ?
          <>
            <span className="truncate">{auth.user.email}</span>
            <span className="shrink-0">
              - <InlineButton onClick={() => auth.signout()}>signout</InlineButton>
            </span>
          </>
        : null
      }
    >
      <div className="simple-page-content">
        {children}
        {/* Demo-only escape hatch: skipping MFA for real users is a product decision we haven't made.
            clearPlan runs in onClick, before the Link navigates. */}
        {__IS_MOCKED__ ?
          <p className="p-md mt-24">
            <Link
              className="a"
              to={plan === 'pro' ? '/signup/pro' : (location.state?.from ?? '/')}
              replace={true}
              onClick={() => clearPlan()}
            >
              Continue (demo)
            </Link>
          </p>
        : null}
      </div>
    </AuthLayout>
  );
}
